import React from 'react';
import Head from 'next/head';
import { baseFontSizePx, color, font, fontWeight } from '../../styles/theme';
import { t } from '../../utils/i18n';

const BasicLayout: React.FunctionComponent<{ children?: React.ReactNode }> = (
  props
) => {
  const browserDefaultFontSize = 16;
  const fontSizeInPercentage = (baseFontSizePx / browserDefaultFontSize) * 100;
  return (
    <div>
      <Head>
        <meta charSet="utf-8" />
        <title>{t('VGM')}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="anonymous"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,300..900;1,300..900&amp;display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css?family=IBM+Plex+Mono:400,400italic,500,600,700&display=swap"
          rel="stylesheet"
        />
        <link rel="icon" href="/favicon/favicon.ico" sizes="32x32" />
        <link rel="icon" href="/favicon/favicon.svg" type="image/svg+xml" />
        <link rel="icon" href="/favicon/favicon-96x96.png" sizes="96x96" />
        <link rel="apple-touch-icon" href="/favicon/apple-touch-icon.png" />
        <link rel="manifest" href="/favicon/site.webmanifest" />
      </Head>
      {props.children}
      {/*language=CSS*/}
      <style jsx global>{`
        html {
          font-size: ${fontSizeInPercentage}%;
          font-family: ${font.primary};
          font-weight: ${fontWeight.regular};
          color: ${color.dark};
          box-sizing: border-box;
          -webkit-font-kerning: normal;
          font-kerning: normal;
          -webkit-font-smoothing: antialiased;
        }

        html,
        body {
          margin: 0;
        }

        *,
        *::before,
        *::after {
          box-sizing: inherit;
        }

        button {
          font-family: inherit;
        }
      `}</style>
    </div>
  );
};

export default BasicLayout;
